import React from 'react';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { Card, CardContent, CardHeader, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Tooltip, CircularProgress } from '@mui/material';
import { SmallFormDateField } from '../../../../../components/small-fields/SmallFormDateField';
import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { formatDate } from '../../../../../services/functions';
import { createEmploymentHistoryAction, deleteEmploymentHistoryAction } from '../../../../../services/request';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useEmployees } from '../../EmployessContext';

function RowForm({ formik, handleClose, loading }) {
  return (
    <TableRow>
      <TableCell width={150}>
        <Stack direction="row" justifyContent="space-around">
          {loading
            ? <CircularProgress size={30}/>
            : <>
              <Tooltip title="zapisz">
                <IconButton color="primary" onClick={formik.handleSubmit}>
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="anuluj">
                <IconButton color="error" onClick={handleClose}>
                  <CancelIcon />
                </IconButton>
              </Tooltip>
            </>}
        </Stack>
      </TableCell>
      <TableCell align="left">
        <SmallFormTextField
          name="company_name"
          onChange={formik.handleChange}
          value={formik.values.company_name}
          sx={{ width: '100%' }}
        />
      </TableCell>
      <TableCell align="left">
        <SmallFormTextField
          name="job_position"
          onChange={formik.handleChange}
          value={formik.values.job_position}
          sx={{ width: '100%' }}
        />
      </TableCell>
      <TableCell align="left">
        <SmallFormDateField
          name="date_from"
          onChange={val => formik.setFieldValue('date_from', formatDate(val))}
          value={formik.values.date_from}
          sx={{ width: '100%' }}
        />
      </TableCell>
      <TableCell align="left">
        <SmallFormDateField
          name="date_to"
          onChange={val => formik.setFieldValue('date_to', formatDate(val))}
          value={formik.values.date_to}
          sx={{ width: '100%' }}
        />
      </TableCell>
    </TableRow>
  );
}

export default function EmploymentHistory() {
  const { rowData, setRowData } = useEmployees();
  const [open, setOpen] = React.useState(false);
  const [editedId, setEditedId] = React.useState(null);
  const { loading, mutate } = useMutation(createEmploymentHistoryAction);
  const { mutate: deleteMutate } = useMutation(deleteEmploymentHistoryAction);

  const formik = useFormik({
    initialValues: {
      company_name: '',
      job_position: '',
      date_from: null,
      date_to: null
    },
    validateOnChange: false,
    onSubmit: values => {
      if (editedId === null) {
        values.employee = rowData.id;
      }
      handleSubmit(values);
    }
  });

  const handleClose = () => {
    setOpen(false);
    setEditedId(null);
    formik.resetForm();
  };


  const handleSubmit = async values => {
    const { error, payload } = await mutate(values, editedId);

    if (!error) {
      if (editedId === null) {
        setRowData(prev => ({ ...prev, employments_history: [payload, ...prev.employments_history] }));
      } else {
        setRowData(prev => ({ ...prev, employments_history: prev.employments_history.map(item => item.id === editedId ? payload : item) }));
      }
      handleClose();
    };
  };

  const handleDelete = async id => {
    const { error } = await deleteMutate(id);
    if (!error) {
      setRowData(prev => ({ ...prev, employments_history: prev.employments_history.filter(item => item.id !== id) }));
    };
  };

  return (
    <Stack spacing={2}>
      <Card>
        <CardHeader
          title="Historia zatrudnienia"
          action={
            editedId !== null || open
              ? null
              : <Tooltip title="dodaj">
                <IconButton color="primary" onClick={() => {
                  setOpen(true);
                  setEditedId(null);
                }}>
                  <AddCircleIcon />
                </IconButton>
              </Tooltip>

          }/>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                  </TableCell>
                  <TableCell align="left">Firma</TableCell>
                  <TableCell align="left">Stanowisko</TableCell>
                  <TableCell align="left">Od</TableCell>
                  <TableCell align="left">Do</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {open ? <RowForm formik={formik} handleClose={handleClose} loading={loading}/> : null}
                {rowData.employments_history?.map(item => (
                  editedId === item.id
                    ? <RowForm formik={formik} handleClose={handleClose} loading={loading}/>
                    : <TableRow key={item.id}>
                      <TableCell align="center" width={150}>
                        <Stack direction="row" justifyContent="space-around">
                          <IconButton color="primary" onClick={() => {
                            setEditedId(item.id);
                            formik.setValues({ company_name: item.company_name, job_position: item.job_position, date_from: item.date_from, date_to: item.date_to });
                            setOpen(false);
                          }}>
                            <EditIcon />
                          </IconButton>
                          <IconButton color="error" onClick={() => handleDelete(item.id)}>
                            <DeleteIcon />
                          </IconButton>
                        </Stack>
                      </TableCell>
                      <TableCell align="left">{item.company_name}</TableCell>
                      <TableCell align="left">{item.job_position}</TableCell>
                      <TableCell align="left">{item.date_from}</TableCell>
                      <TableCell align="left">{item.date_to}</TableCell>
                    </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Stack>
  );
};
